export enum LocalStorageKeys {
  AccessToken = "access-token",
  RefreshToken = "refresh-token",
  usersCsvReport = "Societe_Users.csv.report-meta",
}

type ProfileEncryptedData = {
  _id: string;
  email: string;
  iat: number;
  exp: number;
};

export type CsvReportMeta = {
  date: string;
  count: number;
};

class LocalStorageService {
  private static readonly accessTokenKey = LocalStorageKeys.AccessToken;
  private static readonly refreshTokenKey = LocalStorageKeys.RefreshToken;

  static getAccessToken(): string | null {
    return localStorage.getItem(this.accessTokenKey);
  }

  static setAccessToken(token: string): void {
    localStorage.setItem(this.accessTokenKey, token);
  }

  static deleteAccessToken(): void {
    localStorage.removeItem(this.accessTokenKey);
  }

  static getRefreshToken(): string | null {
    return localStorage.getItem(this.refreshTokenKey);
  }

  static setRefreshToken(token: string): void {
    localStorage.setItem(this.refreshTokenKey, token);
  }

  static deleteRefreshToken(): void {
    localStorage.removeItem(this.refreshTokenKey);
  }

  static deleteAuthTokens(): void {
    this.deleteAccessToken();
    this.deleteRefreshToken();
  }

  static getMyId() {
    const accessToken = this.getAccessToken();

    if (accessToken) {
      const encryptedData = accessToken.split(".")[1];

      const { _id } = JSON.parse(
        atob(encryptedData as string)
      ) as ProfileEncryptedData;

      return _id;
    }
  }
}

export { LocalStorageService };
